import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import bg from "../../assets/images/bg-login.jpg";
import "./resetpassword.css";
import { publicIpv4 } from "public-ip";

const ResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [disabled, setIsDisabled] = useState(false);
    const [ipAddress, setIpAddress] = useState("");

    useEffect(() => {
        document.body.style.backgroundImage = `url(${bg})`;
        document.body.style.backgroundSize = "cover";
        document.body.style.backgroundPosition = "center";
        return () => {
            document.body.style.backgroundImage = "";
        };
    }, []);

    useEffect(() => {
        if (errorMessage || successMessage) {
            const timer = setTimeout(() => {
                setErrorMessage("");
                setSuccessMessage("");
            }, 10000); // 10 seconds
            return () => clearTimeout(timer);
        }
    }, [errorMessage, successMessage]);
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== passwordConfirm) {
            setErrorMessage("Mật khẩu và xác nhận mật khẩu không khớp.");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/password/reset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    token: token,
                    password: password,
                    password_confirmation: passwordConfirm,
                    ip_address: ipAddress,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccessMessage(data.message || "Đổi mật khẩu thành công!");
                setErrorMessage("");
                setIsDisabled(true);
                setTimeout(() => navigate("/"), 3000); // Redirect after 3 seconds
            } else {
                setErrorMessage(data.message || "Đổi mật khẩu thất bại.");
                setSuccessMessage("");
            }
        } catch (error) {
            setErrorMessage("Đã có lỗi xảy ra.");
            setSuccessMessage("");
        }
    };

    return (
        <div className="reset-password-container">
            <div className="reset-password-box">
                <div className="logo-main text-center">
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "8px",
                            marginTop: "-5px",
                            width: "30%",
                        }}
                        className="navbar-brand-full logo-header"
                        src={`${process.env.REACT_APP_IMAGE_LOGO}/images/logo.svg`}
                        alt="TIDADIGI"
                    />
                </div>
                {!disabled ? (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="password">Mật khẩu mới *</label>
                            <input
                                className="form-control"
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password_confirm">Xác nhận mật khẩu *</label>
                            <input
                                className="form-control"
                                id="password_confirm"
                                type="password"
                                value={passwordConfirm}
                                onChange={(e) => setPasswordConfirm(e.target.value)}
                                required
                            />
                        </div>
                        {errorMessage && <div className="error-message">{errorMessage}</div>}
                        {successMessage && <div className="success-message">{successMessage}</div>}
                        <div className="form-actions">
                            <button className="btn btn-primary" type="submit">
                                <i className="fa fa-save" /> Đổi mật khẩu
                            </button>
                        </div>
                    </form>
                ) : (
                    <div>
                        <div className="success-message">{successMessage}</div>
                        <button
                            className="btn btn-secondary"
                            onClick={() => navigate("/")}
                        >
                            Quay lại trang đăng nhập
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
